import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const UsersIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M14 17V15.3333C14 14.4493 13.6839 13.6014 13.1213 12.9763C12.5587 12.3512 11.7956 12 11 12H5C4.20435 12 3.44129 12.3512 2.87868 12.9763C2.31607 13.6014 2 14.4493 2 15.3333V17"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 9C9.65685 9 11 7.65685 11 6C11 4.34315 9.65685 3 8 3C6.34315 3 5 4.34315 5 6C5 7.65685 6.34315 9 8 9Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18 16V14.6371C17.9996 14.0332 17.8029 13.4465 17.4409 12.9692C17.0789 12.4919 16.5721 12.151 16 12"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13 3C13.5721 3.17056 14.0792 3.55796 14.4413 4.10114C14.8034 4.64432 15 5.31238 15 6C15 6.68762 14.8034 7.35567 14.4413 7.89886C14.0792 8.44204 13.5721 8.82944 13 9"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
